import api from '../NetworkService';

/* eslint-disable camelcase */
export interface getAllClientAccountsResponse {
    facebook_ads: {
        accounts: Array<{
            id: string,
            is_associated: boolean,
            name: string,
            content_type_name: string,
        }>
    },
    google_ads: {
        accounts: Array<{
            id: string,
            is_associated: boolean,
            name: string,
            content_type_name: string,
        }>
    }
}
/* eslint-enable camelcase */

export const getAllClientAccounts = (clientId): getAllClientAccountsResponse => api
    .getClient()
    .get(`/api/accounts/association/?client_id=${clientId}`)
    .then(response => response.data)
    .catch(error => error.message);

export const associateAccount = (clientId, contentType, account) => api
    .getClient()
    .post(`/api/clients/${clientId}/account/add/${contentType}/`, {
        name: account.name,
        id: account.id,
        platform_id: account.platform_id,
    });


export const getClientsAndClientsAccounts = (search) => {
    const source = api.getCancelTokenSource();

    const res = api
        .getClient()
        .get('/api/clients/list', { params: { search }, cancelToken: source.token })
        .then(response => response.data)
        .then(data => data.results)
        .catch(error => error.message);
    res.cancel = source.cancel.bind(source);
    return res;
};

export const getClientsAndClientsAccountsConfig = ({ search }) => ({
    url: '/api/clients/list',
    method: 'GET',
    params: {
        search,
    },
});

export const removeAssociateAccount = id => api
    .getClient()
    .delete(`/api/account/${id}/`)
    .then(response => response.data);

export const editAccountDetail = (accountId, data) => api
    .getClient()
    .patch(`/api/account/${accountId}/edit/`, data);
